import React from 'react'
import { Link } from 'react-router-dom'
import {
  formatLastActivity,
  getTerritoryStatusColor,
  getTerritoryKanji,
} from './territoryUtils'
import './TerritoryGrid.css'

const STATUS_ICONS = {
  Guerra: '⚔',
  Paz: '●',
  Tensión: '⚡',
  'Conflicto Interno': '⚡',
  Alianza: '◎',
  Neutral: '◈',
}

export default function TerritoryCard({ territory, compact = false }) {
  const cardClass = compact ? 'territory-card territory-card--compact' : 'territory-card'
  const kanji = getTerritoryKanji(territory)
  const statusColor = getTerritoryStatusColor(territory.territory_status)
  const statusIcon = STATUS_ICONS[territory.territory_status] || '◈'
  const leaderName = territory.emperor_name || territory.leader_name
  const leaderTitle = territory.leader_title || (territory.emperor_name ? 'Emperador' : 'Kage')
  const adventures = Number(territory.adventureCount || 0)
  const characters = Number(territory.characterCount || 0)
  const activityLabel = territory.lastActivity ? formatLastActivity(territory.lastActivity) : null

  return (
    <Link to={`/han/${territory.slug}`} className={cardClass}>
      <div className="territory-card__title-row">
        <div className="territory-card__heading">
          <span className="territory-card__seal" aria-hidden="true">
            {kanji}
          </span>
          <h3 className="territory-card__title">{territory.name}</h3>
        </div>

        {(territory.territory_status || activityLabel) && (
          <div className="territory-card__aside">
            {territory.territory_status && (
              <span className="territory-card__status" style={{ color: statusColor }}>
                <span aria-hidden="true">{statusIcon}</span>
                {territory.territory_status}
              </span>
            )}
            {activityLabel && <span className="territory-card__time">{activityLabel}</span>}
          </div>
        )}
      </div>

      {leaderName && (
        <p className="territory-card__meta">
          <span className="territory-card__leader-title">{leaderTitle}</span>
          {leaderName}
        </p>
      )}

      {!compact && territory.description && (
        <p className="territory-card__description">{territory.description}</p>
      )}

      <footer className="territory-card__foot">
        <dl className="territory-card__stats">
          <div className="territory-card__metric">
            <dd className="territory-card__metric-value">{adventures}</dd>
            <dt className="territory-card__metric-label">Aventuras</dt>
          </div>
          <div className="territory-card__metric">
            <dd className="territory-card__metric-value">{characters}</dd>
            <dt className="territory-card__metric-label">Shinobis</dt>
          </div>
        </dl>
        <span className="territory-card__cta">
          Explorar
          <span className="territory-card__cta-arrow" aria-hidden="true">
            →
          </span>
        </span>
      </footer>
    </Link>
  )
}
